<template>
  <div>
    <div>
      <div class="hero-container">
        <h1 class="hero-title">
          {{ videoStr }}
        </h1>
      </div>
      <div class="video-container">
        <video class="first-video" :src="firstImageUrl" autoplay muted loop playsinline></video>
        <div class="video-placeholder" v-if="!videoLoaded"></div>
      </div>
      <div class="homepage-media">
        <h3 class="area-title">{{ $t('messages.manufactureTitle') }}</h3>
        <div style="background-color: #034277; width: 100%; height: 554px">
          <div class="second-video-container">
            <el-carousel :interval="4000" height="554px" style="width: 800px;">
              <el-carousel-item v-for="(item, index) in secondImageUrl" :key="index">
                <el-image style="width: 800px;height: 554px;" :src="item" fit="contain"></el-image>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
      <div class="wrapper" style="margin-top: 180px">
        <div class="content">
          <h3 class="area-title">{{ $t('messages.ourProducts') }}</h3>
        </div>
        <CategoryMenu></CategoryMenu>
      </div>
      <div class="wrapper" style="margin-top: 180px">
        <div class="content">
          <h3 class="area-title">{{ $t('messages.markets') }}</h3>
        </div>
        <div class="market_container">
          <div class="market" v-for="(item, index) in thirdList" :key="item.cloudPath">

            <div class="image-wrapper">
              <el-image style="width: 400px;height: 400px;" :src="item.url" fit="cover"></el-image>
              <div class="overlay">
                <el-button type="text" @click="gotoMenu(index)" class="overlay-button">{{ returnButonTitle(index)
                  }}</el-button>
                <!-- <div class="overlay-text">这里是一些文字</div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CategoryMenu from "@/components/CategoryMenu.vue";

export default {
  components: {
    CategoryMenu
  },
  data() {
    return {
      isOn: false,
      showMenusIndex: -1,
      firstImageUrl: "",
      secondImageUrl: "",
      firstList: [],
      secondList: [],
      thirdList: [],
      fourthList: [],
      videoLoaded: false,
      videoStr: "",
    };
  },
  computed: {
    isShowMenu() {
      return this.isOn ? "on" : "";
    },


  },

  async mounted() {
    let res = await this.GetUrlsByHttp(this.GlobalData.homeUrl, this.GlobalData.type_home)
    console.log("home res: ", res)
    if (res["1"].length != 0) {
      this.firstImageUrl = res["1"][0]
      console.log("firstImageUrl: ", this.firstImageUrl)
    }
    if (res["2"].length != 0) {
      this.secondImageUrl = res["2"]
    }
    if (res["3"].length != 0) {
      this.thirdList = res["3"][0]
    }
    if (res["5"].length != 0) {
      this.videoStr = res["5"]
    }
    console.log("thirdList: ", this.thirdList[0])
  },

  methods: {
    switchShowMenu(index) {
      // this.isOn = !this.isOn;
      this.showMenusIndex = index;
    },

    initData() {
      this.videoLoaded = false;
    },

    gotoMenu(index) {
      // this.$router.push({ name: "menu", params: { index: index } });
      this.$router.push({ path: "/markets"})

    },

    returnButonTitle(index) {
      switch (index) {
        case 0:
          return this.$t('messages.titleConsumerElectronics');
        case 1:
          return this.$t('messages.titleTesting');
        case 2:
          return this.$t('messages.titleIndustrial');
        case 3:
          return this.$t('messages.titleNewEnergy');
        case 4:
          return this.$t('messages.titleMedical');
        case 5:
          return this.$t('messages.titleComunication');
        default:
          return this.$t('messages.markets');
      }
    },
  },

  watch: {
    firstImageUrl(newValue) {
      if (newValue) {
        this.videoLoaded = true;
      }
    }
  }
};
</script>

<style scoped>
/* 设置视频容器的高度和宽度 */
.video-container {
  width: 100%;
  height: 100%;
  background: black;
  /* height: 554px;  */
  /* position: relative; */
}

/* 使用伪元素模拟视频的外观 */
.video-placeholder {
  width: 100%;
  height: 100%;
  background-color: #000;
  /* background: red; */
  background-size: cover;
  background-position: center;
}

.first-video {
  object-fit: contain;
  overflow-clip-margin: content-box;
  overflow: clip;
  width: 100%;
  height: 100%;
}

.hero-container {
  left: 49px;
  position: absolute;
  left: 73px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
}

.hero-title {
  color: #fff;
  font-size: 40px;
  max-width: 840px;
  text-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1607843137);
  line-height: 55px;
  letter-spacing: 0.4px;
  margin: 0;
  padding-bottom: 21px;
  font-weight: 600;
}

.homepage-media {
  margin-top: 88px;
  position: relative;
}

.area-title {
  font-size: 45px;
  color: #00579C;
  line-height: 56px;
  text-align: center;
  padding-top: 45px;
  position: relative;
  margin: 0;
}

.second-video-container {
  display: flex;
  /* 启用 Flexbox 布局 */
  justify-content: center;
  /* 水平居中 */
  align-items: center;
  /* 垂直居中 */
  width: 100%;
  height: 100%;
}

.wrapper .content .area-title {
  margin: 0;
  text-align: center;
  font-size: 37px;
  color: #00579C;
  line-height: 56px;
  position: relative;
}

.wrapper .content .area-title:after {
  content: "";
  width: 103px;
  height: 6px;
  background-color: #00579C;
  position: absolute;
  left: 50%;
  bottom: -17px;
  transform: translateX(-58%);
}

.market_container {
  margin-left: 100px;
  margin-right: 100px;
  display: flex;
  gap: 34px;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  -webkit-padding-start: 49px;
  padding-inline-start: 49px;
  -webkit-padding-end: 49px;
  padding-inline-end: 49px;
}

.market {
  max-width: 450px;
  height: 450px;
  /* width: 200px; */
  position: relative;
  display: flex;
  flex: 1 0 30%;
  align-items: center;
  /* max-width: 570px;
  height: 550px; */
  background-size: cover;
  border-radius: 10px;
}

.image-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  /* Ensure the wrapper takes the full width */
  height: 100%;
  /* Ensure the wrapper takes the full height */
  border-radius: 10px;
}

.overlay {
  position: absolute;
  bottom: -30px;
  /* 调整这个值来控制垂直方向上的位置 */
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  /* 按钮和文字之间的间距 */
}

.overlay-button {
  width: 350px;
  height: 50px;
  color: #fff;
  font-size: 18px;
  background-color: #00579C;
  border-radius: 10px;
  padding: 10px 20px;
  /* margin-top: 20px; */
}

.overlay-text {
  color: #fff;
}

.about_container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  /* width: 100%; */
  max-width: 100vw;
  height: 565px;
  margin-top: 100px;
  background-size: cover;
}

.homepage-hero {
  width: 100%;
  height: 100%;
}

/deep/ .el-image {
  border-radius: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/home-asx.vue